import { useMemo } from "react";

import { useTenantMemberships } from "@/contexts/TenantContext";
import { CorePermissions } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/CorePermission";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { LAZO_USER_ROLES } from "@/types/LazoUserRoles";

export function useCurrentUserFlags() {
  const { workspaceState } = useTenantMemberships();

  return useMemo(() => {
    const roles = workspaceState.lazoMembership?.roles ?? [];
    const isTeamAdmin = roles.some((r) => r.name === LAZO_USER_ROLES.LAZO_TEAM_ADMIN);
    // Centralize permission checks here so we can expand progressively.
    const isAppAdmin = AuthService.hasPermissionFor(CorePermissions.APP_ADMIN);

    return {
      roles,
      isTeamAdmin,
      isAppAdmin,
    };
  }, [workspaceState.lazoMembership?.roles]);
}
